:host {
  display: block;
  height: 100%;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}

